import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import workerUrlRaw from '@datadog/browser-worker?url';

import { CONFIG } from 'src/modules/window';

const {
  DATADOG_RUM_ENABLED: datadogRUMEnabled,
  ENV: env,
  version,
} = CONFIG || {};

export const initDatadogRUM = () => {
  const workerUrl = new URL(workerUrlRaw, window.location.origin).pathname;

  if (datadogRUMEnabled && workerUrl) {
    datadogRum.init({
      clientToken: 'pub1e710a53acc05327c39bd7e786afe838',
      applicationId: '3fd73f96-78f5-48b5-972c-60663a0e11d5',
      site: 'datadoghq.com',
      service: 'ca-settings-ui',
      env,
      version,
      sessionSampleRate: 10,
      sessionReplaySampleRate: 10,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      plugins: [reactPlugin() as any],
      compressIntakeRequests: true,
      workerUrl,
    });

    datadogRum.setGlobalContextProperty('team', 'profile-experience');
  }
};
